import { rootState } from '@core-interface'

export const getLanguageFromReducer = (state:rootState) => state?.coreReducer?.localization?.selected;
